const HEARTBEAT_WINDOW_MS = 10000

/** 根据最近 10 秒的 1 Hz 飞控心跳计算健康度，供地面站组件共享。 */
export function getHeartbeatHealth (planeState = {}, now = Date.now()) {
  if (!planeState.online || !planeState.heartbeatObservedAt) {
    return { level: 'poor', label: '差', ratio: 0 }
  }

  const samples = Array.isArray(planeState.heartbeatSamples)
    ? planeState.heartbeatSamples.filter(timestamp => timestamp > now - HEARTBEAT_WINDOW_MS).sort((a, b) => a - b)
    : []
  if (!samples.length) return { level: 'poor', label: '差', ratio: 0 }

  const latestAge = Math.max(0, now - samples[samples.length - 1])
  const freshnessScore = latestAge <= 1500 ? 1 : Math.max(0, 1 - (latestAge - 1500) / 3000)
  const intervals = samples.slice(1).map((timestamp, index) => timestamp - samples[index])
  const intervalScore = intervals.length
    ? intervals.reduce((sum, interval) => {
      // 500～1500ms 都视为健康抖动；超过后逐步降级，约 4.5～5 秒才判差。
      if (interval >= 500 && interval <= 1500) return sum + 1
      if (interval < 500) return sum + Math.max(0, interval / 500)
      return sum + Math.max(0, 1 - (interval - 1500) / 5000)
    }, 0) / intervals.length
    : freshnessScore
  const ratio = intervalScore * 0.8 + freshnessScore * 0.2

  if (latestAge >= 4500) return { level: 'poor', label: '差', ratio }
  if (latestAge >= 2500) return ratio >= 0.5 ? { level: 'good', label: '良', ratio } : { level: 'poor', label: '差', ratio }
  if (ratio >= 0.85) return { level: 'excellent', label: '优', ratio }
  if (ratio >= 0.6) return { level: 'good', label: '良', ratio }
  return { level: 'poor', label: '差', ratio }
}

/** 记录一次有效飞控心跳，同时裁剪窗口外的旧采样。 */
export function appendHeartbeatSample (planeState, now = Date.now()) {
  const samples = Array.isArray(planeState.heartbeatSamples) ? planeState.heartbeatSamples : []
  planeState.heartbeatSamples = [...samples.filter(timestamp => timestamp > now - HEARTBEAT_WINDOW_MS), now]
  planeState.heartbeatHealthUpdatedAt = now
  if (!planeState.heartbeatObservedAt) planeState.heartbeatObservedAt = now
}
